import { type EvidenceUploadMode, type ModelResults } from 'api';

import { getAnalysisStatusAndRejectionReason } from '../../utils/getAnalysisStatusAndRejectionReason/getAnalysisStatusAndRejectionReason';

export const useAnalysisStatus = () => {
  const getStatusAndRejectionReason = (mode: EvidenceUploadMode, modelResults?: ModelResults | null) => {
    return getAnalysisStatusAndRejectionReason(mode, modelResults ?? undefined);
  };

  return { getStatusAndRejectionReason };
};
